import {LogService} from "./services/log.service";
import {LogProxy} from "./services/log.proxy";
export {LogManager} from "./services/log.manager";
export {LogCat} from "./services/log.manager.categories";

export let LOG_SERVICES_PROVIDERS=[LogService,LogProxy];
